const mapWlsSearchProperty = (property, featuredImageForGrid) => {
  const unit = (property.units && property.units[0]) || {};
  const slug = property.slug || String(property.id);
  return {
    id: unit.id || property.id,
    name: property.name,
    slug,
    inventory_kind: property.inventory_kind,
    option_count: property.option_count,
    from_price: property.from_price,
    featured_image: featuredImageForGrid(property.featured_image),
    property: {
      id: property.id,
      name: property.name,
      multi_unit: Boolean(property.is_multi_unit),
      property_type: property.property_type
    },
    listings: [
      {
        unit: {
          id: unit.id,
          num_sleep: unit.num_sleep || 4,
          num_bedrooms: unit.num_bedrooms || 0,
          num_bathrooms: unit.num_bathrooms || 0,
          unit_type: unit.unit_type || 'house'
        },
        bookable_nightly_price: unit.bookable_nightly_price || 0,
        bookable_nightly_price_before_promotion:
          unit.bookable_nightly_price_before_promotion || 0
      }
    ],
    location: property.location || { adr_city: '', adr_state: '' },
    num_bedrooms: unit.num_bedrooms || 0,
    num_bathrooms: unit.num_bathrooms || 0,
    default_unit_id: unit.id,
    room_type_id: property.room_type_id,
    room_type_name: property.room_type_name || null
  };
};

module.exports = mapWlsSearchProperty;
